<template>
  <div>
    <h1>About Page</h1>
    <p>Learn more about us on this page.</p>
    <router-link to="/about/team">Meet the Team</router-link>
    <router-link to="/about/contact">Contact Us</router-link>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>